import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { CurrentBookingWizardStepAtom } from "../../atoms/stores";
import { LessonWizardStepContainerNode$key } from "./__generated__/LessonWizardStepContainerNode.graphql";
import { AddPlayersPrivateStep } from "./steps/AddPlayersPrivateStep/AddPlayersPrivateStep";
import { AddPlayersPrivateStepClientProfile$key } from "./steps/AddPlayersPrivateStep/__generated__/AddPlayersPrivateStepClientProfile.graphql";
import { AddPlayersStep } from "./steps/AddPlayersStep/AddPlayersStep";
import { AddPlayersStepClientProfile$key } from "./steps/AddPlayersStep/__generated__/AddPlayersStepClientProfile.graphql";
import { LessonBookingDetailsStep } from "./steps/BookingDetailsStep/LessonBookingDetailsStep";
import { PreviousBookingsStep } from "./steps/PreviousBookingsStep/PreviousBookingsStep";
import { PreviousBookingsStepClientProfile$key } from "./steps/PreviousBookingsStep/__generated__/PreviousBookingsStepClientProfile.graphql";

type Props = {
  nodeRef: LessonWizardStepContainerNode$key | null;
  addPlayersRef: AddPlayersStepClientProfile$key | null;
  addPlayersPrivateRef: AddPlayersPrivateStepClientProfile$key | null;
  previousBookingsRef: PreviousBookingsStepClientProfile$key | null;
  onClose: () => void;
  slots: Array<{
    date: string;
    durationMins: number;
    id: string;
    time: string;
  }>;
};

export const LessonWizardStepContainer = ({
  slots,
  nodeRef,
  addPlayersRef,
  addPlayersPrivateRef,
  previousBookingsRef,
  onClose,
}: Props) => {
  const node = useFragment(
    LessonWizardStepContainerNodeFragmentString,
    nodeRef
  );
  const currentBookingWizardStep = useAtomValue(CurrentBookingWizardStepAtom);

  switch (currentBookingWizardStep) {
    case "BookingDetails":
      return <LessonBookingDetailsStep nodeRef={node ?? null} slots={slots} />;
    case "AddPlayers":
      return (
        <AddPlayersStep
          clientProfileRef={addPlayersRef}
          nodeRef={node ?? null}
        />
      );
    case "AddPlayersPrivate":
      return (
        <AddPlayersPrivateStep
          nodeRef={node ?? null}
          clientProfileRef={addPlayersPrivateRef}
        />
      );
    case "PreviousBookings":
      return (
        <PreviousBookingsStep
          previousBookingsRef={previousBookingsRef}
          previousBookingsTimeSlotRef={node ?? null}
          onClose={onClose}
        />
      );
    default:
      return null;
  }
};

export const LessonWizardStepContainerNodeFragmentString = graphql`
  fragment LessonWizardStepContainerNode on Node {
    ...LessonBookingDetailsStepNode
    ...AddPlayersStepNode
    ...PreviousBookingsStep_TimeSlot
    ...AddPlayersPrivateStepNode
  }
`;
